import { Outlet } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Starfield } from "@/components/Starfield";
import { useSite } from "@/context/SiteContext";

export const PublicLayout = () => {
  const { content } = useSite();
  const wa = content?.whatsapp || "33757829980";
  return (
    <div className="relative min-h-screen bg-[#08080A] overflow-x-hidden">
      <Starfield />
      <Navbar />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer whatsapp={wa} />
      <a
        href={`https://wa.me/${wa}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp-button"
        className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500/20 border border-emerald-400/40 backdrop-blur-md shadow-[0_12px_40px_rgba(0,0,0,0.4)] hover:scale-110 transition-transform"
      >
        <MessageCircle className="text-emerald-300" size={26} />
      </a>
    </div>
  );
};
